<div class="wrapper">
	<div class="content-section">
		<div (click)="isOpenFilters = !isOpenFilters" class="header-block">
			<div class="title-wrapper">
				<h3 class="title">{{ 'filter_section.filter' | translate }}</h3>
				<p class="title-info">{{ 'filter_section.info' | translate }}</p>
			</div>

			<ion-icon [class.isOpen]="isOpenFilters" src="../../../assets/topgolf/triangle.svg"></ion-icon>
		</div>
		<div [class.show-filters]="isOpenFilters" class="filter_wrapper">
			@for (item of listFilters; track $index) {
				<div [class.bottom-line]="$index < listFilters?.length - 1" class="filter_item">
					<div>
						<ion-label>
							<ion-item class="ion-text-wrap ion-no-padding" lines="none" mode="md">
								<ion-toggle
									(ionChange)="changeVariable($event, item.value)"
									[checked]="addedFilters.includes(item.value)"
									slot="end"
								></ion-toggle>
							</ion-item>
						</ion-label>
					</div>
					<p>{{ item.name | translate }}</p>
				</div>
			}
		</div>
	</div>

	<!-- <div>
        <ion-button (click)="selectFilters()">Filter</ion-button>
    </div> -->
</div>
